export enum ContactInfoTypesEnum {
    email,
    phone
}
